/**
 * Logic for the correct value of "main_modules2" and "fire_basic_coverage" fields
 * which depends on fields "basic_coverage_postcode_validation_contents"
 * and "basic_coverage_postcode_validation_building" from quote responce.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (quoteExtraData) => {
      if (!quoteExtraData) {
        kasko.dispatchEvent('set-state-input', {
          main_modules2_quote_settings: false,
          fire_basic_coverage_quote_settings: false,
          main_modules2: false,
          fire_basic_coverage: false,
        });
        kasko.dispatchEvent('set-form-input', {
          main_modules2_quote_settings: false,
          fire_basic_coverage_quote_settings: false,
          main_modules2: false,
          fire_basic_coverage: false,
        });
        kasko.dispatchEvent('trigger-requests');
      }
    },
    { slice: 'quote.data.extraData' },
  );
};
